export default __webpack_public_path__ + "static/media/cancel.497bed7f.svg";